<template>
  <div class="edit-page">
    <div class="edit-product-container" v-if="order">
      <ordering-bread :order-status="0"></ordering-bread>
      <div class="applicant-container">
        <div class="step-box">
          <img
            class="step-1-icon"
            src="@/assets/imgs/ordering/step_1.png"
            alt=""
          />
          <span class="step-title-text">出行人</span>
        </div>
        <div class="applicant-container-content">
          <div
            class="applicant-li"
            v-for="item in order.applicant"
            :key="item.order_applicant_id"
          >
            <img class="icon-applicant" 
            src="@/assets/imgs/ordering/icon_app_check.png" alt="" />
            <div class="applicant-name">{{ item.applicant_name }}</div>
          </div>
        </div>
      </div>
      <div class="search-product-container">
        <div class="step-box">
          <img
            class="step-1-icon"
            src="@/assets/imgs/ordering/step_2.png"
            alt=""
          />
          <span class="step-title-text">改签国家/签证</span>
        </div>
        <div class="search-product-content">
          <div class="old-product">
            <div class="old-product-label">原商品</div>
            <div class="old-product-title">
              {{ oldProduct.product_name_short }}
            </div>
          </div>
          <div class="new-product">
            <div class="new-product-left">新商品</div>
            <div class="new-product-right">
              <div class="new-product-search-container">
                <el-input
                  v-model="productId"
                  placeholder="输入商品编号搜索"
                  @keydown.enter="handleSearch"
                  :maxlength="15"
                  @input.native="handleNativeInput"
                ></el-input>
                <div class="search-btn" @click="handleSearch">搜索</div>
              </div>
              <div class="new-product-search-tips">
                请在商品详情页查看对应商品编号，或者咨询您的签证专家
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-result-container" v-if="isSearch">
        <div class="step-box">
          <img
            class="step-1-icon"
            src="@/assets/imgs/ordering/step_3.png"
            alt=""
          />
          <span class="step-title-text">选择新签证商品</span>
        </div>
        <div class="search-result-content">
          <div
            class="search-result-list"
            v-if="productId && productList && productList.length > 0"
          >
            <product-item
              v-for="item in productList"
              :key="item.visa_product_id"
              :countryInfo="countryInfo"
              :product="item"
              :province-code="provinceCode"
              :selected-id="selectId"
              @updateActive="handleSelectId"
            ></product-item>
          </div>
          <div class="empty" v-else>
            <img
              class="empty-img"
              src="@/assets/imgs/ordering/search_no_data.png"
            />
            <div class="empty-text">没有找到签证，请重试</div>
          </div>
        </div>
      </div>
    </div>
    <div class="edit-footer">
      <div class="edit-footer-inner">
        <el-button type="default" @click="$router.back()"  style="font-size: 16px;">取消</el-button>
        <el-button type="primary" :disabled="!selectId" :class="{'btn-disabled': !selectId}" style="font-size: 16px;" @click="goProductDetail"
          >确定 </el-button
        >
      </div>
    </div>

    <created-order-dialog
      :visible.sync="addOrderModalShow"
      :product="currentProduct"
      :from="from"
      :copy-order="order"
    ></created-order-dialog>
  </div>
</template>
<script>
import productItem from './order-edit-product-item.vue';
import Http from '../../../libs/http';
import orderingBread from '../components/ordering-bread';
import CreatedOrderDialog from '@/components/add-order/created-order/created-order-dialog.vue';

export default {
  props: {
    countryInfo: Object,
    provinceCode: Number,
    entryCountType: Number,
  },
  components: {
    productItem,
    orderingBread,
    CreatedOrderDialog,
  },
  data() {
    return {
      productId: '',
      currentProduct: {},
      order: {},
      oldProduct: {}, // 为了拿到商品的简称
      productList: [],
      isSearch: false,
      selectId: 0,
      addOrderModalShow: false,
      from: '',
    };
  },

  created() {
    this.initData();
  },
  methods: {
    initData() {
      const oldId = +this.$route.query.id;
      Http.post('/order_query', { user_order_id: oldId })
        .then((res) => {
          this.order = res;
          if (this.order && Object.keys(this.order).length > 0) {
            this.handleGetOldProduct(this.order.visa_product_id);
          }
        })
        .catch((e) => {
          this.order = {};
          console.log(e);
        });
    },
    handleProductRequest(pid, status) {
      return Http.post('/visa_product_query', {
        visa_product_id: +pid,
        status: status === 0 ? 0 : undefined,
      });
    },
    handleNativeInput(event) {
      const value = event.target.value;
      // 使用正则过滤非数字字符
      this.productId = value.replace(/\D/g, '');
    },
    handleSearch() {
      if (!this.productId) return;
      this.isSearch = true;
      this.selectId = 0;
      this.handleProductRequest(this.productId, 0)
        .then((res) => {
          if (Object.keys(res).length > 0) {
            if (res.visa_product_id === this.order.visa_product_id) {
              res.isOld = true;
            }
            // 之前是展示多个商品，后面是精准搜索展示一个
            this.productList = [res];
          } else {
            this.productList = [];
          }
          
        })
        .catch((e) => {
          this.productList = [];
          console.log(e);
        });
    },
    handleGetOldProduct(pid) {
      this.handleProductRequest(pid)
        .then((res) => {
          this.oldProduct = res;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleSelectId(id) {
      this.selectId = id;
    },
    goProductDetail() {
      this.currentProduct = this.productList.find(
        item => item.visa_product_id === this.selectId,
      );
      // 如果复制线下的订单 新商品不支持线下订单，不能切换产品，会提示：当前商品不支持切换产品
      if (this.order.offline === 1 && this.currentProduct.offline !== 1) {
        this.$message.error('当前商品不支持切换产品');
        return false;
      }
      this.addOrderModalShow = true;
    },
  },
};
</script>
<style lang="less" scoped>
.edit-page {
  display: flex;
  flex-direction: column;
  .edit-product-container {
    display: flex;
    flex-direction: column;
    width: 1120px;
    margin: 0 auto;
    padding-bottom: 130px;
    .applicant-container {
      width: 100%;
      background: #ffffff;
      padding: 20px 24px;
      .applicant-container-content {
        width: 100%;
        min-height: 60px;
        background: #fafbfc;
        border-radius: 2px;
        padding: 22px 24px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 32px;
        .applicant-li {
          display: flex;
          justify-content: flex-start;
          gap: 10px;
          .icon-applicant {
            display: block;
            width: 15px;
            height: 15px;
          }
          .applicant-name {
            font-size: 16px;
            color: #2f333d;
          }
        }
      }
    }

    .step-box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      // gap: 8px;
      height: 60px;
      align-items: center;
      .step-1-icon {
        display: block;
        width: 28px;
        height: 28px;
        margin-right: 8px;
      }
      .step-title-text {
        font-weight: 500;
        font-size: 20px;
        color: #2f333d;
        line-height: 28px;
      }
    }
    .search-product-container {
      width: 100%;
      padding: 20px 24px;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      background: #fff;
      .search-product-content {
        display: flex;
        flex-direction: column;
        background: #fafbfc;
        padding: 0 24px;
        .old-product {
          display: flex;
          justify-content: flex-start;
          gap: 16px;
          padding: 20px 0;
          align-items: center;
          border-bottom: 1px dashed #dee2e6;
          .old-product-label,
          .old-product-title {
            font-size: 16px;
            color: #2f333d;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .old-product-label {
            font-weight: 500;
            width: 55px;
          }
          .old-product-title {
            font-weight: 400;
            flex: 1;
            line-height: 24px;
          }
        }

        .new-product {
          display: flex;
          justify-content: flex-start;
          gap: 16px;
          padding: 20px 0;
          .new-product-left {
            font-size: 16px;
            color: #2f333d;
            font-weight: 500;
            margin-top: 11px;
          }
          .new-product-right {
            display: flex;
            flex-direction: column;
            gap: 8px;
            .new-product-search-container {
              display: flex;
              justify-content: flex-start;
              gap: 16px;
              /deep/ .el-input {
                width: 340px;
                height: 40px;
                .el-input__inner {
                  height: 40px;
                  line-height: 40px;
                }
              }
              .search-btn {
                width: 100px;
                height: 40px;
                line-height: 40px;
                background: #599fff;
                border-radius: 2px;
                font-size: 16px;
                color: #fff;
                font-weight: 400;
                text-align: center;
                cursor: pointer;
                &:hover {
                  opacity: 0.88;
                }
              }
            }
            .new-product-search-tips {
              font-weight: 400;
              font-size: 12px;
              color: #91999f;
              line-height: 12px;
            }
          }
        }
      }
    }
    .search-result-container {
      margin-top: 20px;
      width: 100%;
      background: #fff;
      padding: 20px 24px;
      .search-result-content {
        background: #fafbfc;
        padding: 24px 20px;
        border-radius: 2px;
        .search-result-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
          .search-result-li {
            width: 100%;
            height: 78px;
            background: #ffffff;
            box-shadow: 0px 2px 6px 0px rgba(47, 51, 61, 0.06);
            display: flex;
            justify-content: flex-start;
            .search-result-li-id {
              width: 90px;
              height: 78px;
              line-height: 78px;
              background: #ffffff;
              box-shadow: 2px 0px 4px 0px rgba(47, 51, 61, 0.06);
            }
            .search-result-li-right {
              display: flex;
              justify-content: space-between;
              gap: 20px;
              .search-result-li-product {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 10px;
                padding: 16px 0;
              }
              .search-result-li-price {
                margin-right: 34px;
              }
            }
          }
        }
        .empty {
          width: 100%;
          height: 337px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 23px;
          .empty-img {
            display: block;
            width: 125px;
            height: 94px;
          }
          .empty-text {
            font-size: 14px;
            color: #6f6f6f;
          }
        }
      }
    }
  }

  .edit-footer {
    width: 100%;
    height: 104px;
    background: #fff;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    .edit-footer-inner {
      width: 1120px;
      height: 104px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 24px;
      font-size: 16px;
      /deep/ .el-button {
        width: 200px;
        height: 50px;
        &:hover {
          color: #599fff;
          border-color: #599fff;
        }
        &--primary {
          background: #599fff;
          &:hover {
            color: #fff;
            opacity: 0.88;
          }
        }
      }
    }
  }
  .btn-disabled{
    background: #BCD8FF!important;
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/ordering/components/order-edit-product.vue